import React from 'react'
import PropTypes from 'prop-types'

function LinkButtonWithIcon (props) {
  const buttonClass = prop => prop ? 'btn-' + prop : null

  const classNames = [
    'btn',
    buttonClass(props.color),
    buttonClass(props.size),
    buttonClass(props.width)
  ]

  if (props.iconPosition === 'right') {
    return (
      <a href={props.href} className={classNames.join(' ')}>
        {props.text}
        <svg className='-mr-1 ml-2 h-5 w-5' viewBox='0 0 20 20' fill='currentColor'>
          {props.iconPath}
        </svg>
      </a>
    )
  }

  return (
    <a href={props.href} className={classNames.join(' ')}>
      <svg className='-ml-1 mr-2 h-5 w-5' viewBox='0 0 20 20' fill='currentColor'>
        {props.iconPath}
      </svg>
      {props.text}
    </a>
  )
}

LinkButtonWithIcon.defaultProps = {
  color: 'primary',
  href: '#'
}

LinkButtonWithIcon.propTypes = {
  /**
     * Button text
     */
  text: PropTypes.string.isRequired,
  /**
     * Color of the button<br>
     * Colors: 'primary', 'white', 'bordered'
     */
  color: PropTypes.string,
  /**
     * Size of the button<br>
     * Sizes: 'default', 'small'
     */
  size: PropTypes.string,
  /**
     * Width of the button<br>
     * Sizes: 'default', 'wide', 'full'
     */
  width: PropTypes.string,
  /**
     * Link HREF attribute
     */
  href: PropTypes.string,
  /**
     * Icon SVG paths
     */
  iconPath: PropTypes.node.isRequired,
  /**
     * Icon position. Can be either 'left' or 'right'
     */
  iconPosition: PropTypes.string
}

export default LinkButtonWithIcon
